import { create } from 'zustand';

// Client-only UI state: which single wallet/Cash App method the deposit flow is
// pinned to (drives Stripe/Checkout wallet gating). Set once by the deposit
// method picker, read across the deposit steps.
interface WalletFlags {
    isApplePayOnly: boolean;
    isGooglePayOnly: boolean;
    isCashAppOnly: boolean;
}

interface PaymentsWalletState extends WalletFlags {
    actions: {
        setWalletFlags: (flags: WalletFlags) => void;
    };
}

export const usePaymentsWalletStore = create<PaymentsWalletState>()((set) => ({
    isApplePayOnly: false,
    isGooglePayOnly: false,
    isCashAppOnly: false,
    actions: {
        setWalletFlags: (flags) =>
            set({
                isApplePayOnly: flags.isApplePayOnly,
                isGooglePayOnly: flags.isGooglePayOnly,
                isCashAppOnly: flags.isCashAppOnly,
            }),
    },
}));
